export default "__VITE_PUBLIC_ASSET__f61e1cb9__"